import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Arrow,
  ClockFilled,
  ProfilesGroup,
  TickIcon,
} from "../../components/Icons";
import {
  CameraOrange,
  CameraWhite,
} from "../../components/student/StudentModuleIcons";
import StudentLayout from "../../layouts/StudentLayout";

const BuyCourse = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const price = location.state?.price;
  const courseId = location.state?.courseId;
  const purchaseType = location.state?.purchaseType;
  const goToCheckout = (purchaseType) => {
    navigate("/student/checkout", {
      state: {
        courseId,
      },
    });
  };

  const goToSelectClassTime = () => {
    navigate("/student/select-class-time", {
      state: {
        courseId,
      },
    });
  };

  const liveFeatures = [
    "Interactive sessions with instructor",
    "Real-time Q&A and discussions",
    "Scheduled daily classes",
    "Certificate upon completion",
  ];

  const recordedFeatures = [
    "Learn at your own pace",
    "High-quality video lessons",
    "4 Months access to content",
    "Certificate upon completion",
  ];


  return (
    <StudentLayout>
      <section className="p-6 sm:p-8 lg:p-12 xl:p-16 font-['Roboto']">
        <button
          onClick={() => navigate(-1)}
          className="inline-flex items-center justify-center text-black"
          aria-label="Go back"
        >
          <Arrow />
        </button>

        <div className="mt-2 text-center text-black">
          <h1 className="text-3xl sm:text-4xl xl:text-5xl  xl:leading-[56px] font-bold ">
            Choose Your Learning Path
          </h1>
          <p className="mt-2 text-base md:text-lg leading-6">
            Select the option that best fits your schedule and learning style
          </p>
        </div>

        <div className="mt-10 md:mt-16 lg:mt-20 xl:mt-24 flex fle-col   justify-center sm:flex-row gap-12 sm:gap-20 xl:gap-28 max-w-[1174px] mx-auto">
          {purchaseType === "Live Classes" ? (
            <article className="rounded-[18px]  bg-[#F5F5F5] shadow-[0_0_9.8px_1px_#00000040] p-6 md:p-8 xl:p-11 ">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-4 sm:gap-7">
                  <ProfilesGroup />
                  <h2 className="text-xl sm:text-2xl  leading-6 font-bold text-black">
                    Live Classes
                  </h2>
                </div>
                <span className="rounded-full bg-[#FFF480] px-3 sm:px-5 py-1 sm:py-2 text-sm sm:text-xl  text-black">
                  Popular
                </span>
              </div>

              <ul className="mt-10 md:mt-16 space-y-3 sm:space-y-4">
                {liveFeatures.map((feature) => (
                  <li
                    key={feature}
                    className="flex items-center gap-3 sm:gap-5"
                  >
                    <TickIcon />
                    <span className="text-base sm:text-xl text-black ">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 md:mt-10 lg:mt-12 flex items-center gap-3 sm:gap-5">
                <span className="text-3xl sm:text-4xl leading-8 sm:leading-[44px] text-black">
                  Rs {price}
                </span>
                {/* <span className=" text-[#938A96] line-through">$399</span> */}
              </div>
              <p className="mt-1 sm:mt-2  text-[#938A96] leading-6">
                One-time payment
              </p>

              <button
                type="button"
                onClick={goToSelectClassTime}
                className="inline-flex items-center gap-3 justify-center mt-4 w-full bg-[#FF6636] text-white text-base sm:text-xl font-bold py-3  hover:opacity-90 transition-opacity"
              >
                <ClockFilled /> <span>Choose Live Classes</span>
              </button>
            </article>
          ) : (
            <article className="rounded-[18px]  bg-[#F5F5F5] shadow-[0_0_9.8px_1px_#00000040] p-6 md:p-8 xl:p-11">
              <div className="flex items-center gap-4 sm:gap-7">
                <CameraOrange />
                <h2 className="text-xl sm:text-2xl  leading-6 font-bold text-black">
                  Recorded Classes
                </h2>
              </div>

              <ul className="mt-14 md:mt-20 space-y-3 sm:space-y-4">
                {recordedFeatures.map((feature) => (
                  <li
                    key={feature}
                    className="flex items-center gap-3 sm:gap-5"
                  >
                    <TickIcon />
                    <span className="text-base sm:text-xl text-black ">
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <div className="mt-8 md:mt-10 lg:mt-12 flex items-center gap-3 sm:gap-5">
                <span className="text-3xl sm:text-4xl  leading-8 sm:leading-[44px] text-black">
                  Rs {price}
                </span>
                {/* <span className=" text-[#938A96] line-through">$299</span> */}
              </div>
              <p className="mt-1 sm:mt-2  text-[#938A96] leading-6">
                One-time payment
              </p>

              <button
                type="button"
                onClick={() => goToCheckout("Recorded Classes")}
                className="inline-flex items-center gap-3 justify-center mt-4 w-full bg-[#FF6636] text-white text-base sm:text-xl font-bold py-3  hover:opacity-90 transition-opacity"
              >
                <CameraWhite /> <span>Choose Recorded Classes</span>
              </button>
            </article>
          )}
        </div>
      </section>
    </StudentLayout>
  );
};

export default BuyCourse;
